import $ from 'jquery';

export default {
  moveExUrl: function (code, param) {
    let url = `/${code}`;

    if (param) {
      Object.entries(param).forEach((item, i) => {
        url = `${url}${i === 0 ? '?' : '&'}${item[0]}=${item[1]}`;
      });
    }

    // location.href = `#${url}`;
    document.location.href = `#${url}`;
  },
  toFixed: function (value) {
    if (value == '' || value == null || value == undefined) return Number(0);
    return Number(value.toFixed(2));
  },
  formatBytes: function (bytes, decimals = 2) {
    if (bytes === 0) return '0 Bytes';

    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  },
  moveUrlLoginCheck: function (url, login) {
    document.location.href = '/#/' + url;
  },
  moveUrlNewTab: function (url) {
    let win = window.open(url, '_blank');
    win.focus();
  },
  krwComma: (str) => {
    let num = Number(str).toFixed(2);
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    // return str.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  },
  zeroFill: (number) => {
    return parseInt(number, 10) < 10 ? '0' + number : number;
  },
};
